/* eslint-disable no-return-await */
import jwtDecode from 'jwt-decode'
import axios from 'services/axiosBase'
import { toast } from 'react-toastify'
import { logout } from 'redux/auth/actions'
import history from 'utils/history'

export const baseUrl = process.env.REACT_APP_KYE_API

const service = async (
  method,
  url,
  token,
  data = null,
  params = null,
  location = null,
  signal = null,
  quiet = false,
  throwErrors = false,
  contentType = 'application/json',
  responseType = undefined,
  accept = undefined,
) => {
  if (!token) {
    logout()
    return history.push({
      pathname: '/login',
      state: {
        from: location,
      },
    })
  }

  const decoded = jwtDecode(token)
  const current_time = Date.now() / 1000

  if (decoded.exp < current_time) {
    toast.error('Seu acesso expirou, faça login novamente.')
    logout()
    return history.go({
      pathname: '/login',
      state: { from: location },
    })
  }
  try {
    const res = await axios({
      method: method,
      url: `${baseUrl}${url}`,
      headers: {
        'Content-Type': contentType,
        'Accept': accept,
        Authorization: `Bearer ${token}`,
      },
      responseType: responseType,
      crossDomain: true,
      params,
      data: data,
      signal: signal,
    })
    return res.data
  } catch (error) {
    if (throwErrors || (signal && signal.aborted)) {
      throw error
    }

    if (quiet) {
      return null
    }

    if (error.response) {
      if (error.response.status === 500) {
        toast.error('Erro interno no servidor. Tente novamente mais tarde.')
      } else if (error.response.data.message) {
        toast.error(error.response.data.message)
      } else if (error.response.data.detail) {
        toast.error(error.response.data.detail)
      }
    } else {
      toast.error('Houve um erro ao realizar esta ação')
    }
  }
  return null
}

export const get = async ({
  url,
  token,
  params,
  location,
  signal,
  quiet = false,
  throwErrors = false,
  responseType = undefined,
  accept = undefined,
}) => {
  return await service('GET', url, token, null, params, location, signal, quiet, throwErrors, undefined, responseType, accept)
}

export const post = async ({
  url,
  token,
  data,
  params,
  location,
  signal,
  quiet = false,
  throwErrors = false,
  contentType = 'application/json',
}) => {
  return await service('POST', url, token, data, params, location, signal, quiet, throwErrors, contentType)
}

export const put = async ({
  url,
  token,
  data,
  params,
  location,
  signal,
  quiet = false,
  throwErrors = false,
  contentType = 'application/json',
}) => {
  return await service('PUT', url, token, data, params, location, signal, quiet, throwErrors, contentType)
}

export const patch = async ({
  url,
  token,
  data,
  params,
  location,
  signal,
  quiet = false,
  throwErrors = false,
  contentType = 'application/json',
}) => {
  return await service('PATCH', url, token, data, params, location, signal, quiet, throwErrors, contentType)
}

export const remove = async ({
  url,
  token,
  data,
  params,
  location,
  signal,
  quiet = false,
  throwErrors = false,
  contentType = 'application/json',
}) => {
  return await service('DELETE', url, token, data, params, location, signal, quiet, throwErrors, contentType)
}
